/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { getHistogramsByMonths } from '../../../_integrations/everymundo/histogram';
import { makeSureTheseAreFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonPreloads';
import { getDateRange } from '../../../components/containers/_commons/dateRange';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: {
          integrationSettings,
          prePopulation,
          visibleItemsAmount = 6,
          uiDatesYearsAdjustmentPatch,
          prePopulation: { originCity, destinationCity },
          meta,
          pageContext
        }
      },
      name,
      simulateSSR
    } = cmpConfig;
    const filters = Object.assign({}, prePopulation, {
      origin: originCity,
      destination: destinationCity,
      dateRange: getDateRange(prePopulation, visibleItemsAmount),
      uiDatesYearsAdjustmentPatch
    });
    delete filters.originCity;
    delete filters.destinationCity;
    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(getHistogramsByMonths(filters, integrationSettings, meta, pageContext));
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([other, histogramByMonthData]) => {
        cmpConfig.containerConfig.settings.getHistogramsByMonths = getHistogramsByMonths;
        cmpConfig.containerConfig.settings.initialHistograms = histogramByMonthData.histograms;
        // NOTE: Is weird that there are trasnformations in the calendar and not here...
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = makeSureTheseAreFlatFares(
          histogramByMonthData.histograms
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};
export default preloadCustomProps;
